import React from 'react';

// Summarizes a request log's overall status as a small badge — shown on the
// collapsed <summary> line so the status is visible without expanding the log.
// Priority: any failure wins (even if some requests are still pending), then
// in-progress, then all-succeeded.
// This app's stylesheet overrides the bg-success/bg-secondary/bg-danger
// utility classes with brand colors (!important), so the real Bootstrap
// badge colors are applied inline here instead of via those classes.
export default function RequestLogBadge({ requestLog }) {
  const failedCount = requestLog.filter((entry) => entry.ok === false).length;
  const hasPending = requestLog.some((entry) => entry.pending);

  if (failedCount > 0) {
    return (
      <span className="badge" style={{ backgroundColor: '#dc3545', color: '#fff' }}>
        {failedCount} error{failedCount === 1 ? '' : 's'}
      </span>
    );
  }

  if (hasPending) {
    return <span className="badge" style={{ backgroundColor: '#6c757d', color: '#fff' }}>In progress...</span>;
  }

  return <span className="badge" style={{ backgroundColor: '#28a745', color: '#fff' }}>All succeeded</span>;
}
